export default [
  {
    path: '/api/poy-details',
    name: 'poy-details-docs',
    component: () => import('@/views/api/PoyDetailsDocs.vue'),
    meta: {
      resource: 'api',
      action: ['read', 'update'],
      pageTitle: 'poyDetailsDocs.pageTitle',
      navActiveLink: 'api-setting',
      breadcrumb: [
        { text: 'Api Setting', to: { name: 'api-setting' } },
        { text: 'poyDetailsDocs.breadcrumb', active: true },
      ],
    },
  },
  {
    path: '/api/setting',
    name: 'api-setting',
    component: () => import('@/views/api/Api.vue'),
    meta: {
      resource: 'api',
      action: ['read', 'update'],
      pageTitle: 'Api Setting',
      breadcrumb: [
        {
          text: 'Api Setting',
          active: true,
        },
      ],
    },
  },
  {
    path: '/api/setting-transfer',
    name: 'api-setting-transfer',
    component: () => import('@/views/api/ApiTransferWallet.vue'),
    meta: {
      resource: 'transfer',
      action: ['read', 'update'],
      pageTitle: 'Api Setting (Transfer Wallet)',
      breadcrumb: [
        {
          text: 'Api Setting (Transfer Wallet)',
          active: true,
        },
      ],
    },
  },
  {
    path: '/api/log',
    name: 'api-log',
    component: () => import('@/views/api/Log.vue'),
    meta: {
      resource: 'api',
      action: ['read', 'update'],
      pageTitle: 'Api Log',
      breadcrumb: [
        {
          text: 'Api Log',
          active: true,
        },
      ],
    },
  },
  {
    path: '/api/log-transfer',
    name: 'api-log-transfer',
    component: () => import('@/views/api/LogTransferWallet.vue'),
    meta: {
      resource: 'transfer',
      action: ['read', 'update'],
      pageTitle: 'Api Log (Transfer Wallet)',
      breadcrumb: [
        {
          text: 'Api Log (Transfer Wallet)',
          active: true,
        },
      ],
    },
  },
  {
    path: '/api/fail',
    name: 'api-fail',
    component: () => import('@/views/api/Fail.vue'),
    meta: {
      resource: 'api',
      action: ['read', 'update'],
      pageTitle: 'Api Fail',
      breadcrumb: [
        {
          text: 'Api Fail',
          active: true,
        },
      ],
    },
  },
]
